import { axiosInstance } from "../../utils/axios";
import { CpmUser } from "../models/cpm-user";

export function fetchCpmUser(): Promise<CpmUser> {
  return axiosInstance.get(`/cpmuser`).then((resp) => resp.data);
}
